module.exports = __webpack_public_path__ + "static/img/close.13a01499.svg";